import React, { Component } from 'react';
import LeftSection from './LeftSection';
import RightSection from './RightSection';

class Home extends Component {
  state = {
    spare: false,
    calculated: false,
    consultation: false,
    checked: false,
    result: null,
  };

  toggleSpare = () => {
    const { spare } = this.state;
    this.setState(() => ({ spare: !spare }));
  }

  setCalculated = () => {
    this.setState(() => ({ calculated: true }));
  }

  setConsultation = () => {
    this.setState(() => ({ consultation: true }));
  }

  setResult = (result) => {
    this.setState(() => ({ result }));
  }

  setChecked = (checked) => {
    this.setState(() => ({ checked }));
  }

  resetApp = () => {
    this.setState(() => ({
      spare: false,
      calculated: false,
      consultation: false,
      checked: false,
      result: null,
    }));
  }

  render() {
    const {
      spare,
      calculated,
      result,
      consultation,
      checked,
    } = this.state;
    return (
      <div className="home">
        <LeftSection
          spare={spare}
          result={result}
          calculated={calculated}
          setCalculated={this.setCalculated}
          setResult={this.setResult}
          setConsultation={this.setConsultation}
          setChecked={this.setChecked}
          resetApp={this.resetApp}
        />
        <RightSection
          spare={spare}
          toggleSpare={this.toggleSpare}
          calculated={calculated}
          consultation={consultation}
          result={result}
          checked={checked}
          resetApp={this.resetApp}
        />
      </div>
    );
  }
}

export default Home;
